export default __webpack_public_path__ + "static/listing-3-05471f13aeae0185422fc56e9e3656ff.png";